<template>
  <CusElCarousel :interval="400000" type="card" height="360px" style="width: 1200px;">
    <CusElCarouselItem v-for="item in dataList" :key="item.id">
      <div class="flex_column" style="">
        <el-image style="width: 286px;height: 180px;" :src="item.imgUrl"
                  fit="fit"></el-image>
        <div class="flex_column" style="justify-content: space-between;height:150px;margin: 16px;text-align: left">
          <div class="title_font">{{ item.title }}</div>
          <div class="time_font">{{ $timeUtil.getYearMonthDate(item.time) }}</div>
        </div>

      </div>
    </CusElCarouselItem>
  </CusElCarousel>
</template>

<style scoped>
.title_font {
  font-size: 16px;
  font-weight: 600;
}

.time_font {
  font-size: 12px;
}
</style>

<script>
import CusElCarousel from "@/components/cus/carousel/index";
import CusElCarouselItem from "@/components/cus/carousel-item/index";

export default {
  components: {
    CusElCarouselItem,
    CusElCarousel
  },
  props: {
    dataList: Array
  }
}
</script>